import { combineReducers } from 'redux'

import admin from './modules/admin/slice'
import customers from './modules/customers/slice'
import orders from './modules/orders/slice'
import products from './modules/products/slice'

export default combineReducers({
  admin,
  customers,
  orders,
  products,
})
